/* global ROUTES, $R */

import getOptionsFromPrefix from '../helpers/getOptionsFromPrefix';

// require('../vendor/redactor-plugins/source/source');
require('../vendor/redactor-plugins/table/table');
require('../vendor/redactor-plugins/video/video');

require('./Redactor/MediaPlugin');
require('./Redactor/FilePlugin');
require('./Redactor/FormattingPlugin');
require('./Redactor/DefinedLinks');
require('./Redactor/RelLinks');

let redactorDefaults = {
  imageUpload: ROUTES.redactorImageUpload,
  fileUpload: ROUTES.redactorFileUpload,
  formatting: ['p', 'h1', 'h2', 'h3', 'blockquote'],
  buttons: [
    'html', 'format', 'bold', 'italic', 'underline',
    'ol', 'ul', 'link',
  ],
  plugins: ['table', 'video', 'media', 'file', 'p', 'h1', 'h2', 'h3', 'definedlinks', 'rellinks'],
  minHeight: '200px',
  pastePlainText: true,
  pasteImages: false,
  toolbarFixed: false,
  animation: false,
  definedlinks: window.API.sitemap,
  definedlinksAutocomplete: false,
  rellinks: [
    '',
    'nofollow noopener',
    'noreferrer noopener',
    'external noopener',
    'author',
    'alternate',
    'prev',
    'next',
    'bookmark',
    'license',
    'search',
    'tag',
  ],
  structure: true,
  linkTitle: true,
  linkNewTab: true,
};

if (typeof window.REDACTOR_OPTIONS !== 'undefined') {
  redactorDefaults = Object.assign(redactorDefaults, window.REDACTOR_OPTIONS);
}

const Redactor = {
  /**
   * Create Redactor element
   * @param {HTMLElement} node
   * @param {Object} props
   * @return {Void}
   */
  create(node, props) {
    // Load plugins for Redactor, can't do this at the top of the file because of missing $

    // Extend the default options with any given inline options with data attributes
    const options = Object.assign({}, redactorDefaults, getOptionsFromPrefix(props, 'redactor'));

    // Create Redactor on element with options
    $R(node, options);
  },
};

export default Redactor;
